import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges
} from '@angular/core';

import { disabledProviderFactory, WithDisabled } from '../../helpers';
import { ButtonSize, ComponentStyle } from '../../models';

enum DropdownType {
  Default = 'default',
  Custom = 'custom'
}

enum MenuPosition {
  Default = 'left',
  Right = 'right'
}

@Component({
  selector: 'pcs-dropdown',
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    disabledProviderFactory(DropdownComponent)
  ],
})
export class DropdownComponent implements WithDisabled, OnChanges {

  @Input() disabled = false;
  @Input() buttonId = '';
  @Input() icon;
  @Input() buttonText = '';
  @Input() buttonStyle = ComponentStyle.Default;
  @Input() buttonSize = ButtonSize.Default;
  @Input() menuPosition = MenuPosition.Default;
  @Input() dropdownType = DropdownType.Default;
  @Input() tabIndex;
  @Input() title = '';
  @Input() container;

  @Output() clicked = new EventEmitter();

  ddClasses = null;
  menuClasses = null;
  buttonClasses = null;

  ngOnChanges({dropdownType, menuPosition, buttonStyle}: SimpleChanges): void {
    if (dropdownType) {
      this.ddClasses = this.calculateDropdownClasses();
    }
    if (menuPosition) {
      this.menuClasses = this.calculateMenuClasses();
    }
    if (buttonStyle) {
      this.buttonClasses = this.calculateButtonClasses();
    }
  }

  onClick($event) {
    if (!this.disabled) {
      this.clicked.emit($event);
    }
  }

  isDropdownDefault() {
    return this.dropdownType === DropdownType.Default;
  }

  isDropdownCustom() {
    return this.dropdownType === DropdownType.Custom;
  }

  private calculateDropdownClasses() {
    return {
      'dropdown-custom': this.isDropdownCustom()
    };
  }

  private calculateMenuClasses() {
    return {
      'dropdown-menu-right': this.isMenuRight()
    };
  }

  private calculateButtonClasses() {
    return {
      'btn-basic': this.isDefault(),
      'btn-invert': this.isPrimary() || this.isSuccess() || this.isInfo() || this.isWarning() || this.isDanger()
    };
  }

  private isDefault() {
    return this.buttonStyle === ComponentStyle.Default;
  }

  private isPrimary() {
    return this.buttonStyle === ComponentStyle.Primary;
  }

  private isSuccess() {
    return this.buttonStyle === ComponentStyle.Success;
  }

  private isInfo() {
    return this.buttonStyle === ComponentStyle.Info;
  }

  private isWarning() {
    return this.buttonStyle === ComponentStyle.Warning;
  }

  private isDanger() {
    return this.buttonStyle === ComponentStyle.Danger;
  }

  private isMenuRight() {
    return this.menuPosition === MenuPosition.Right;
  }

}
